import { render } from "./CenterBox.vue?vue&type=template&id=6ca4092d&scoped=true"
import script from "./CenterBox.vue?vue&type=script&lang=js"
export * from "./CenterBox.vue?vue&type=script&lang=js"

import "./CenterBox.vue?vue&type=style&index=0&id=6ca4092d&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca4092d"]])

export default __exports__